<header role="banner" class="content__header">
        <div class="header-leave-button">
            <app-button
                    [cssClasses]="'btn basic-leave solid__gray-02'"
                    [icon]="'logout'"
                    [hideLabelMobileOnly]="true"
                    [ariaLabel]="('GENERAL.LEAVE' | translate) + ('GENERAL.BUTTON' | translate)"
                    (buttonClicked)="leaveIndication.emit()">
                {{'GENERAL.LEAVE' | translate}}
            </app-button>
        </div>
        <div class="header-info">
            <h1 class="header-info__unit-title">{{informationUnitTitle}}</h1>
        </div>
        <div class="header-controls">
            <div class="header-tts-buttons">
                <div class="header-controls__play">
                    <app-button
                            [ariaLabel]="((ttsIconState === playState ? 'SCREEN_READER.HEADER.PLAY_BUTTON' : 'SCREEN_READER.HEADER.PAUSE_BUTTON') | translate) + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'solid__blue-08 circle wh-80'"
                            [iconState]="ttsIconState"
                            [iconSize]="'60'"
                            [basicMode]="true"
                            (buttonClicked)="readText()">
                    </app-button>
                </div>
            </div>
        </div>
</header>
